<script setup>
import { useHubPageTitle } from '../../composables/useHubPageTitle';
import HubIdentity from './HubIdentity.vue';

defineProps({
  showMenuButton: { type: Boolean, default: false },
});

defineEmits(['open-nav']);

const title = useHubPageTitle();
</script>

<template>
  <header class="hub-topbar">
    <button
      v-if="showMenuButton"
      type="button"
      class="hub-topbar__menu"
      aria-label="Open navigation"
      @click="$emit('open-nav')"
    >
      <span aria-hidden="true">☰</span>
    </button>

    <h1 class="hub-topbar__title" data-xl-gen="northstar" :title="title">{{ title }}</h1>

    <!-- Where every page's PageHeader teleports its actions. Pages keep owning
         what their buttons do; the shell owns where they sit. -->
    <div id="hub-topbar-actions" class="hub-topbar__actions" />

    <HubIdentity />
  </header>
</template>

<style scoped>
.hub-topbar {
  position: sticky;
  top: 0;
  /* Under the sidebar's 52, so the sidebar's rounded right corner stays on
     top of the bar rather than being clipped by it. */
  z-index: 51;
  display: flex;
  align-items: center;
  gap: 16px;
  height: var(--hub-topbar-height, 64px);
  flex-shrink: 0;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3), 0 1px 3px 1px rgba(0, 0, 0, 0.15);
  /* +10px clears the sidebar's margin-right:-10px overlap band, which exists
     so the page's grey slides under the sidebar's rounded corner. Without it
     the title starts underneath the sidebar. */
  padding: 0 var(--setup-page-padding, 40px) 0 calc(var(--setup-page-padding, 40px) + 10px);
}

.hub-topbar__menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-left: -8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.hub-topbar__title {
  flex: 1;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-height: 0;
  background: none;
  font-family: var(--xl-font-family);
  font-size: 15.5px;
  font-weight: 700;
  line-height: normal;
  color: var(--xl-color-on-surface);
}

.hub-topbar__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.hub-topbar__actions::-webkit-scrollbar {
  display: none;
}

@media (max-width: 900px) {
  .hub-topbar {
    padding: 0 16px;
  }
}
</style>
